'use strict';

import { companyUnity, areaOther, countryStateCity } from '../../modules/select';
import { stepFiveValidate } from '../../modules/validator/pages/stepFive';
import { formFields } from '../../modules/formFields';
import { customFile } from '../../modules/customFile';
import { dragDrop } from '../../modules/dragDrop';

export const stepFive = () => {
  stepFiveValidate();
  companyUnity();
  areaOther();
  formFields();
  customFile();
  dragDrop();
  countryStateCity();

  const $company = $('#company_id');
  const $cimentosFields = $('[data-cimentos]');

  $company.on('change', function (e) {
    if (e.target.value == 11) {
      $cimentosFields.show();
    } else {
      $cimentosFields.hide();
    }
  });
};
